import {useTranslation} from "react-i18next";
import {Divider} from "@mui/material";
import {Form, Formik} from "formik";

import {addNewSampleImages, deleteSampleImage} from "../../../../slices/SampleFunctionalSlice";
import {TextInput} from "../../../Inputs";
import QRSampleModalPart from "../../../SamplesList/SampleUniModal/SampleUniModalParts/QRSampleModalPart";
import SampleTabPart from "../../SampleTabPart/SampleTabPart";
import useUpdateTab from "../useUpdateTab";

import useEditSampleTab from "./useEditSampleTab";

const EditSampleTabBase = ({setTabs}) => {
  const {t} = useTranslation();

  const {typeForm, sample} = useEditSampleTab();

  useUpdateTab({typeForm, sampleId: sample?.sampleId});

  return (
    <div className="h100">
      <div className="h100" style={{paddingTop: "1em"}}>
        <Form className="fcCol h100">
          <div className="fc jcsb aibl">
            <div className="mb">{t("inst")}</div>
            <TextInput label={t("BM")} width="17em" name="brandManager" disabled />
          </div>
          <Divider />

          <div className="w">
            <SampleTabPart typeForm={typeForm} setTabs={setTabs} />
            <QRSampleModalPart
              typeForm={typeForm}
              isCreate={false}
              sample={sample}
              images={sample?.images ?? []}
              addMethod={addNewSampleImages}
              deleteMethod={deleteSampleImage}
            />
          </div>
        </Form>
      </div>
    </div>
  );
};

const EditSampleTab = ({setTabs}) => {
  const {validationSchema, initialValues} = useEditSampleTab();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnChange={true}
      validateOnBlur={false}
      enableReinitialize
    >
      <EditSampleTabBase setTabs={setTabs} />
    </Formik>
  );
};

export default EditSampleTab;
